import { type PropsWithChildren } from 'react';

import type { SiteSkipLinkType } from './SiteSkipLinks';

import { useTemporaryImperativeFocus } from '../../../common/hooks/useTemporaryImperativeFocus';

const SkipLinkTarget = (props: PropsWithChildren<{ id: SiteSkipLinkType }>) => {
    const { ref, onBlurCapture } = useTemporaryImperativeFocus<HTMLDivElement>();

    return (
        <div id={props.id} ref={ref} onBlurCapture={onBlurCapture}>
            {props.children}
        </div>
    );
};

export default SkipLinkTarget;
